<template>
	<sf-data-table
		ref="grpTable"
		:paging="false"
		:excel="isButton_(scrId, 'EX')"
		:columns="cols"
		:rows="rows"
		:stripe="false"
		:selection="false"
		:span-method="spanMethod"
	>
		<template v-slot:customRows="slotProps">
			<template v-for="(item, index) in monthlabel">
				<template v-if="slotProps.column.property === item">
					<template v-if="slotProps.row.itemCd == '20' || slotProps.row.itemCd == '30'">
						<td
							:key="index"
							class="col-1"
							style="all: unset; cursor: pointer; text-align: right"
							@click="onGoClick(slotProps.row[slotProps.column.property], slotProps)"
						>
							{{ slotProps.row[slotProps.column.property] }}
						</td>
					</template>

					<template v-else>
						{{ slotProps.row[slotProps.column.property] }}
					</template>
				</template>
			</template>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers'; //공통
import { serviceComputed, serviceMethods } from '@pqy/pcku/MdjYGraph/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			monthlabel: '',
			cuRslt: '',
			bfRslt: ''
		};
	},
	created() {
		this.monthlabel = this.monthlabel_;
	},

	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.mdjTbList;
		},
		cols() {
			return this.mdjYGraphCols_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		resetTable() {
			this.$emit('Refresh');
		},
		async onGoClick(argsCnt, rowsInfo) {
		
		},
		spanMethod({ row, column, rowIndex, columnIndex }) {
			if (columnIndex === 0) {
				if (rowIndex % 7 === 0) {
					return {
						rowspan: 7,
						colspan: 1
					};
				} else {
					return {
						rowspan: 0,
						colspan: 0
					};
				}
			}
		}
	}
};
</script>

<style></style>
